import { AxiosInstance, AxiosError } from 'axios';
import { Store } from 'vuex';

import { AppState } from '@/store';
import { Logger } from '../logger/logger';
import { AnalyticsService } from '../analytics/analytics.service';
import { OrderApiError } from '@/models';

export const HEADER_KEY_CORRELATION_ID = 'Chipotle-CorrelationId';
export const HEADER_KEY_KASADA_BYPASS = 'x-chipotle-bypass';
export const ERROR_DATA = 'errorData';

export abstract class ApiService {
  constructor(protected store: Store<AppState>, protected httpClient: AxiosInstance, protected logger: Logger, protected analytics: AnalyticsService) {}

  logAndThrowApiError(operationName: string, error: AxiosError): never {
    const metaData: any = {};
    if (error.config && error.config.headers) {
      metaData[HEADER_KEY_CORRELATION_ID] = error.config.headers[HEADER_KEY_CORRELATION_ID];
    }

    const axiosOrderError = error as AxiosError<OrderApiError[], any>;
    if (axiosOrderError && axiosOrderError.response && axiosOrderError.response?.data?.length > 0) {
      metaData[ERROR_DATA] = axiosOrderError.response?.data;
    }
    
    this.logger.error(`Something went wrong while executing '${operationName}'`, metaData, error);

    throw error;
  }

  protected isAxiosErrorWithStatusCode(error: any, status: number): boolean {
    return !!(error as AxiosError).response && (error as AxiosError).response!.status == status;
  }
}
